<div class="body ui" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <div class="ui breadcrumb">
          <div class="section ash">Home</div>
          <div class="divider">/</div>
          <div class="section ash">Settings</div>
        </div>
        <!-- Title -->
        <h2 class="ui primary header fw-bold">
          {{ workflow.workflowGroupDescription }} Groups
        </h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px"></div>
  </div>

  <div class="ui divider" appMargin marginY="3"></div>

  <div
    class="ui segment"
    style="border-radius: 4px; border: none"
    appMargin
    marginT="0"
    appPadding
    paddingX="0px" paddingY="0px"
  >
    <app-search-filter
      [filter]="filter"
      (onSearch)="searchRecords($event)"
      (onDisplayRows)="displayRecords($event)"
      (onSort)="sortRecords($event)"
    ></app-search-filter>
  </div>

  <div class="ui basic segment" *ngIf="success || error">
    <div class="ui success message" *ngIf="success">
      <i (click)="close()" class="close icon"></i>
      {{ success }}
    </div>
    <div class="ui warning message" *ngIf="error">
      <i (click)="close()" class="close icon"></i>
      {{ error | json }}
    </div>
  </div>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      id="dark"
    >
      <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div>
      <div fxFlex="15%">Name</div>
      <div fxFlex="15%">Level</div>
      <div fxFlex="15%">Number of Users</div>
      <div fxFlex="grow">List of Users</div>

      <div fxFlex="17%"></div>
    </div>

    <app-no-record-found
      *ngIf="workflowGroups && workflowGroups.length < 1"
    ></app-no-record-found>
    <app-no-record-found *ngIf="!workflowGroups"></app-no-record-found>

    <div
      class="ui segment"
      *ngFor="let group of workflowGroups"
      appMargin
      marginB="3"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
    >
      <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div>
      <div fxFlex="15%">{{ group?.workflowGroupName }}</div>
      <div fxFlex="15%">{{ group?.level }}</div>
      <div fxFlex="15%">{{ group?.users.length }}</div>
      <div fxFlex="grow">
        <span *ngFor="let user of group.users" style="display: block">
          {{ user | createdBy }},
        </span>
      </div>
      <div fxFlex="17%" class="text-right">
        <div
          style="height: fit-content; padding: 10px 15px"
          class="ui primary mini basic dropdown button"
          suiDropdown
        >
          <div class="text">Actions</div>
          <i class="dropdown icon"></i>
          <div class="left menu primary" suiDropdownMenu>
            <div class="item primary" (click)="assignUsers(group)">
              Assign Users
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon button" (click)="getPage(currentPage)">
            <i class="refresh icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="true"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
